// Animazioni Scroll per Azienda Agricola Moretti
document.addEventListener('DOMContentLoaded', function() {
  
  // Animazioni attivate solo quando servono, senza controlli continui a ogni scroll.
  const animatedElements = document.querySelectorAll('.animate-on-scroll');
  if (animatedElements.length) {
    if ('IntersectionObserver' in window) {
      const animationObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('animated');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.1 });
      animatedElements.forEach((element) => animationObserver.observe(element));
    } else {
      animatedElements.forEach((element) => element.classList.add('animated'));
    }
  }

  // Animazioni hover per card prodotto
  const productCards = document.querySelectorAll('.card-wrapper, .product-card, .card');

  function resetProductCardHoverState() {
    productCards.forEach(function(card) {
      card.style.removeProperty('transform');
      card.style.removeProperty('transition');
    });
  }
  
  // Su dispositivi touch non servono gli handler hover: meno listener e meno effetti indesiderati.
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    productCards.forEach(function(card) {
      card.addEventListener('mouseenter', function() {
        this.style.transform = 'translateY(-8px)';
        this.style.transition = 'all 0.3s ease';
      });

      card.addEventListener('mouseleave', function() {
        this.style.transform = 'translateY(0)';
      });
    });
  }

  // Evita che il browser ripristini una card ancora sollevata tornando indietro.
  // pagehide pulisce lo stato prima della BFCache; pageshow copre il ripristino back/forward.
  window.addEventListener('pagehide', resetProductCardHoverState);
  window.addEventListener('pageshow', function(event) {
    const navigationEntry = performance.getEntriesByType('navigation')[0];
    if (event.persisted || navigationEntry?.type === 'back_forward') {
      resetProductCardHoverState();
      window.requestAnimationFrame(resetProductCardHoverState);
    }
  });

  // Smooth scroll per link interni
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#' && document.querySelector(href)) {
        e.preventDefault();
        document.querySelector(href).scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

});
